import axiosSecure from '@api/axiosSecure';
import getContextRoot from '@api/getContextRoot';

const deleteCompany = async (companyId: number | string): Promise<any> => {
  const res = await axiosSecure.delete(`${getContextRoot()}/company/${companyId}`);
  return res.data;
};

export default deleteCompany;
